import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

// Fill is necessary: UX didn't reference the other existing graphics and used the lighter color after our CSS opacity, so this corrects their mistake.

const SupportImage = props => (
    <SvgIcon {...props} viewBox="0 0 105 110">
        <path
            d="M98.828 36.753C98.338 16.41 81.67 0 61.208 0h-9.416c-20.463 0-37.13 16.409-37.62 36.753C5.716 41.641 0 50.761 0 61.208c0 10.43 5.697 19.535 14.125 24.427v3.823c0 12.981 10.56 23.542 23.542 23.542H56.5a4.71 4.71 0 0 0 0-9.417H37.667c-7.788 0-14.125-6.337-14.125-14.125v-.423c1.535.258 3.102.423 4.708.423 1.883 0 3.785-.193 5.64-.57a4.704 4.704 0 0 0 3.777-4.614V38.143a4.704 4.704 0 0 0-3.776-4.614 28.5 28.5 0 0 0-5.641-.57c-1.478 0-2.92.151-4.341.368 2.1-13.518 13.786-23.91 27.883-23.91h9.416c14.097 0 25.783 10.392 27.883 23.91-1.422-.217-2.863-.368-4.341-.368a28.5 28.5 0 0 0-5.64.57 4.704 4.704 0 0 0-3.777 4.614V84.28a4.704 4.704 0 0 0 3.776 4.614c1.856.372 3.758.565 5.641.565 15.58 0 28.25-12.67 28.25-28.25 0-10.447-5.716-19.567-14.172-24.455"
            clipRule="evenodd"
            fillRule="evenodd"
            fill="#3777bc"
        />
    </SvgIcon>
);

export default SupportImage;
